<div class="wrapper-page-container">
  <app-bread-crumbs [breadcrumbs]="breadcrumbs"></app-bread-crumbs>
  <div class="container mt-5">
    @if (!isLoading) {
      <app-buyer-catalogue-pageheader
        [consignorName]="consignorName"
        [consignorId]="consignorId"
        [auctionInfo]="auction"
        [type]="auctionTypeParams"
        [translations]="catalogueTranslation"
        (actionFired)="handleActions($event, $event.detail)"
        [isLoading]="isLoading"
        [gradualEnding]="auction?.gradual_ending_settings"
      >
      </app-buyer-catalogue-pageheader>
      <div class="catalog-options-section" [class.expanded]="isExpanded">
        <div class="catalog-options-top">
          <app-pagination-results
            [translationsAuction]="catalogueTranslation"
            [paginationData]="paginationData"
          ></app-pagination-results>
          <div class="catalog-actions">
            <button
              class="action-btn"
              (click)="openBidIncrements()"
              data-translation-key="buyer_catalogue_bid_increments"
            >
              {{ "buyer_catalogue.bid_increments" | translate }}
            </button>
            @if (auction?.seller_terms != null) {
              <button
                class="action-btn"
                (click)="goToTermsAndConditions()"
                data-translation-key="buyer_catalogue_terms_conditions"
              >
                {{ "buyer_catalogue.terms_conditions" | translate }}
              </button>
            }
            @if (auction?.sales_statistics !== null) {
              <button
                (click)="openCatalogueStats()"
                class="action-btn"
                data-translation-key="buyer_catalogue_stats"
              >
                {{ "buyer_catalogue.stats" | translate }}
              </button>
            }
            <div class="filters-toggle">
              <button
                (click)="toggleFilters()"
                class="btn-hide"
                [ngClass]="{ 'btn-show': isExpanded }"
                [disabled]="availableDynamicFilters?.length === 0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M20.5 6.1001C20.5 5.54005 20.4996 5.25981 20.3906 5.0459C20.2948 4.85774 20.1423 4.70487 19.9542 4.60899C19.7403 4.5 19.4597 4.5 18.8996 4.5H6.09961C5.53956 4.5 5.25981 4.5 5.0459 4.60899C4.85774 4.70487 4.70487 4.85774 4.60899 5.0459C4.5 5.25981 4.5 5.54005 4.5 6.1001V6.83736C4.5 7.08195 4.5 7.20433 4.52763 7.31942C4.55213 7.42146 4.59263 7.51893 4.64746 7.6084C4.70928 7.70928 4.79591 7.79591 4.96875 7.96875L10.0315 13.0315C10.2044 13.2044 10.2904 13.2904 10.3523 13.3914C10.4071 13.4808 10.4482 13.5786 10.4727 13.6807C10.5 13.7946 10.5 13.9155 10.5 14.1552V18.911C10.5 19.7682 10.5 20.1971 10.6805 20.4552C10.8382 20.6806 11.0814 20.831 11.3535 20.8712C11.6651 20.9172 12.0487 20.7257 12.8154 20.3424L13.6154 19.9424C13.9365 19.7819 14.0966 19.7013 14.2139 19.5815C14.3176 19.4756 14.397 19.3485 14.4453 19.2084C14.5 19.0499 14.5 18.87 14.5 18.511V14.1626C14.5 13.918 14.5 13.7958 14.5276 13.6807C14.5521 13.5786 14.5926 13.4808 14.6475 13.3914C14.7089 13.2911 14.7947 13.2053 14.9653 13.0347L14.9688 13.0315L20.0315 7.96875C20.2044 7.7958 20.2904 7.70932 20.3523 7.6084C20.4071 7.51893 20.4482 7.42146 20.4727 7.31942C20.5 7.20551 20.5 7.08444 20.5 6.8448V6.1001Z"
                    stroke="#033A09"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div class="layout-toggle">
              <button
                (click)="toggleLayout()"
                class="toggle-btn border-left-radius--8"
                [ngClass]="{ active: !isCardLayout }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g>
                    <rect x="0" y="0" width="20" height="3.64741" rx="1.8237" />
                    <rect x="0" y="8" width="20" height="3.64741" rx="1.8237" />
                    <rect
                      x="0"
                      y="16"
                      width="20"
                      height="3.64741"
                      rx="1.8237"
                    />
                  </g>
                </svg>
              </button>
              <button
                (click)="toggleLayout()"
                class="toggle-btn border-right-radius--8"
                [ngClass]="{ active: isCardLayout }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <g clip-path="url(#clip0_1610_1442)">
                    <rect width="5.10638" height="5.10638" rx="2.55319" />
                    <rect
                      y="7.44678"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      y="14.8937"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="7.44678"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="7.44678"
                      y="7.44678"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="7.44678"
                      y="14.8937"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="14.8936"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="14.8936"
                      y="7.44678"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                    <rect
                      x="14.8936"
                      y="14.8937"
                      width="5.10638"
                      height="5.10638"
                      rx="2.55319"
                    />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <app-catalogue-filters
          class="p-0"
          [fields]="filterFields"
          [selectedFilters$]="selectedFilters$"
          [isLoadingState$]="isLoadingState$"
          [isExpanded]="isExpanded"
          [activeFilters]="activeFilters"
          [translations]="catalogueTranslation"
          [disableAllFilters]="catalogData.length === 0 && !hasActiveFilters"
          (filtersChanged)="onFiltersChanged($event)"
        ></app-catalogue-filters>
      </div>
      <!-- Empty State - No Items, No Filters -->
      @if (catalogData.length === 0 && !hasActiveFilters) {
        <app-no-data
          [showImg]="false"
          [message]="{
            message: 'buyer_catalogue.no_items_yet' | translate,
            translationsKey: 'buyer_catalogue_no_items_yet',
          }"
          [subMessage]="{ subMessage: '', translationsKey: '' }"
        ></app-no-data>
      }
      <!-- Empty State - No Results with Active Filters -->
      @if (catalogData.length === 0 && hasActiveFilters) {
        <app-no-data
          [showImg]="false"
          [message]="{
            message: 'buyer_catalogue.no_results_found' | translate,
            translationsKey: 'buyer_catalogue_no_results_found',
          }"
          [subMessage]="{
            subMessage: 'buyer_catalogue.try_adjusting_filters' | translate,
            translationsKey: 'buyer_catalogue_try_adjusting_filters',
          }"
        ></app-no-data>
      }
      @if (catalogData.length > 0) {
        <div class="row g-4 mb-60">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            @if (!isCardLayout) {
              <div class="wrapper-page-table-container">
                <app-base-table
                  class="mt-5 catalogue-table"
                  [tableColumns]="tableColumns"
                  [tableData]="catalogData | search: searchVal : ['name']"
                  [isLoading]="isLoading"
                  (onTableRowClicked)="rowClicked($event)"
                  [rowClassFn]="getRowClass"
                  [tableStyle]="'buyer'"
                >
                </app-base-table>
              </div>
            }
          </div>
          @if (isCardLayout) {
            @for (
              item of catalogData | search: searchVal : ["name"];
              track item.id
            ) {
              <div
                class="col-xl-4 col-md-4 item"
                [class.wow]="auction?.gradual_ending_settings == null"
                [class.animate]="auction?.gradual_ending_settings == null"
                [class.fadeInDown]="auction?.gradual_ending_settings == null"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <app-auction-item-card
                  [data]="item"
                  (click)="cardClicked(item)"
                  [auctionType]="auctionType"
                  [translations]="catalogueTranslation"
                  [loggedIn]="loggedIn"
                  [auctionSettings]="auctionSettings"
                  [userId]="user_id"
                  [gradualEnding]="auction?.gradual_ending_settings"
                  [dir]="dir"
                  [auction]="auction"
                  [horseOffers]="{
                    offers: item?.offers,
                    make_an_offer: item?.make_an_offer,
                  }"
                  (loadData)="onCardTimerEnded(item.id)"
                  [locale]="locale"
                  (favoriteClicked)="onFavoriteClick($event)"
                  [showType]="false"
                  [showHip]="true"
                  [isFromCatalogue]="true"
                >
                </app-auction-item-card>
              </div>
            }
          }
        </div>
      }
      @if (catalogData.length > 0) {
        <div>
          <app-pagination
            [currentPage]="page || 1"
            [totalPages]="paginationData?.totalPages"
            (pageChanged)="onPageChanged($event)"
          >
          </app-pagination>
        </div>
      }
    }
    @if (isLoading) {
      <div class="row g-4 mb-60">
        @for (item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track item) {
          <app-skeleton-loader
            class="col-xl-3 col-lg-4 col-md-6"
            type="auction-card"
          ></app-skeleton-loader>
        }
      </div>
    }
  </div>
</div>
<ng-template #timeLeftTemplate let-element="element">
  <app-timer
    [endDate]="element.extended_end_date"
    [currentDate]="element.current"
    [auc_type]="'active'"
    [showProgressPar]="false"
    (loadData)="handleTimeEnded(element, 'list')"
    [timerType]="'table_cell'"
    [translations]="catalogueTranslation"
  ></app-timer>
</ng-template>
<ng-template #auctionNameTemplate let-element="element">
  <span class="table-img__container bold-text horse-name">
    <img [src]="element?.image || '/assets/images/defualt-image.jpg'" />
    {{ element | horseName }}
    @if (element.has_update && element.withdrawn_at == null) {
      <button
        type="button"
        class="info-button"
        [matTooltip]="element.update_content"
        matTooltipPosition="right"
        matTooltipClass="material-tooltip buyer-theme horse-updates"
        [matTooltipShowDelay]="300"
        [matTooltipHideDelay]="500"
        [attr.aria-label]="'Information about ' + element.update_content"
        (click)="
          $event.stopPropagation(); $event.preventDefault(); tooltip?.toggle()
        "
        #tooltip="matTooltip"
      >
        <i class="bi bi-info-circle"></i>
      </button>
    }
  </span>
</ng-template>
<ng-template #actionsTemplate let-element="element">
  @if (element.withdrawn_at == null) {
    <div class="table__btns">
      @if (auctionType == "wishlist") {
        <button
          class="icon-outlined-btn"
          [disabled]="element.deleteClicked"
          (click)="
            handleActions($event, {
              propagation: true,
              action: 'delete',
              id: element?.id,
            });
            $event.stopPropagation()
          "
        >
          <svg
            width="16"
            height="15"
            viewBox="0 0 16 15"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629ZM8.00013 14.8125C-6.375 5.31378 3.57406 -2.09995 7.83512 1.8216C7.89138 1.87317 7.94669 1.9266 8.00013 1.98192C8.05303 1.92665 8.10807 1.87349 8.16513 1.82254C12.4253 -2.10182 22.3753 5.31284 8.00013 14.8125Z"
            />
          </svg>
        </button>
      }
      @if (
        (auctionType == "active" &&
          (!element?.winnerUser || !element?.soldUser)) ||
        auctionType == "upcoming"
      ) {
        <button
          [disabled]="element.wishlistClicked"
          class="icon-outlined-btn"
          [class.bid]="element.in_user_wishlist"
          (click)="
            handleActions($event, {
              propagation: true,
              action: !element.in_user_wishlist ? 'fav' : 'unfav',
              id: element?.id,
            })
          "
        >
          @if (!element.in_user_wishlist) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M22.9623 5.23905C22.2899 4.1728 21.3051 3.33981 20.1421 2.85358C18.8244 2.30045 17.3443 2.20089 15.862 2.56638C14.5037 2.90134 13.1806 3.62786 12 4.6818C10.8192 3.62777 9.49599 2.9012 8.13746 2.56628C6.65513 2.20066 5.17496 2.30031 3.85721 2.85381C2.6942 3.34019 1.70944 4.17335 1.03716 5.23975C0.333099 6.35275 -0.025073 7.70627 0.00136453 9.15381C0.11874 15.589 9.70477 21.4408 11.6252 22.5486C11.7392 22.6143 11.8684 22.6489 12 22.6489C12.1315 22.6489 12.2608 22.6143 12.3747 22.5486C14.2954 21.4406 23.8823 15.5879 23.9986 9.15269C24.0248 7.70523 23.6664 6.35186 22.9623 5.23905ZM22.4989 9.12573C22.4614 11.2064 21.0744 13.6322 18.4881 16.1408C16.093 18.4638 13.3687 20.2148 12 21.0295C10.6312 20.215 7.9073 18.4642 5.51246 16.1411C2.92608 13.6327 1.53905 11.2071 1.50108 9.12644C1.45965 6.85455 2.5576 5.02666 4.43808 4.23677C5.05438 3.97935 5.71602 3.84805 6.38391 3.85061C8.10868 3.85061 9.93315 4.68555 11.4652 6.24339C11.535 6.31436 11.6182 6.37073 11.71 6.4092C11.8018 6.44768 11.9003 6.46749 11.9999 6.46749C12.0994 6.46749 12.198 6.44768 12.2898 6.4092C12.3816 6.37073 12.4648 6.31436 12.5346 6.24339C14.663 4.07917 17.3557 3.31028 19.5612 4.23663C21.4419 5.02623 22.5399 6.85384 22.4989 9.12559V9.12573Z"
                fill="#033A09"
              />
            </svg>
          }
          @if (element.in_user_wishlist) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12 22.6489C11.8684 22.6489 11.7392 22.6143 11.6252 22.5486C9.70477 21.4408 0.11874 15.589 0.00136453 9.15381C-0.025073 7.70627 0.333099 6.35275 1.03716 5.23975C1.70944 4.17335 2.6942 3.34019 3.85721 2.85381C5.17496 2.30031 6.65513 2.20066 8.13746 2.56628C9.49599 2.9012 10.8192 3.62777 12 4.6818C13.1806 3.62786 14.5037 2.90134 15.862 2.56638C17.3443 2.20089 18.8244 2.30045 20.1421 2.85358C21.3051 3.33981 22.2899 4.1728 22.9623 5.23905C23.6664 6.35186 24.0248 7.70523 23.9986 9.15269C23.8823 15.5879 14.2954 21.4406 12.3747 22.5486C12.2608 22.6143 12.1315 22.6489 12 22.6489Z"
                fill="#033A09"
              />
            </svg>
          }
        </button>
      }
      <app-bid-now-button
        [classStyle]="'bid-btn btn-sm'"
        [dir]="dir"
        [elementId]="element?.id"
        [slug]="element?.slug"
        [translations]="catalogueTranslation"
        [condition]="
          element.can_bid &&
          (auctionType == 'active' ||
            auctionType == 'wishlist' ||
            auctionType == 'bids')
        "
        [isGuest]="loggedIn"
        [terms]="{
          buyer_accepted: auction?.buyer_accepted_seller_terms,
          seller_terms: auction?.seller_terms,
          auction_id: auction?.id,
        }"
        [buyerStatus]="auction?.buyer_status"
        [sellerEmail]="auction?.seller_email"
      ></app-bid-now-button>
      @if (
        (auctionType == "upcoming" || auctionType == "active") &&
        (!loggedIn ||
          auctionSettings.auction_buyer_last_record ||
          (auctionSettings.auction_buyer_last_record === null &&
            !auctionSettings.request_to_join_status &&
            !auctionSettings.invited_buyer &&
            !auctionSettings.accepted_invited_buyer))
      ) {
        <app-request-to-bid-button
          class="width-100"
          [loggedIn]="loggedIn"
          [auctionSettings]="auctionSettings"
          [translations]="catalogueTranslation"
          [horseDetails]="{
            auc_id: element.auc_id,
            buyer_document_categories: element.buyer_document_categories,
          }"
          [aucType]="auctionType"
          [terms]="{
            buyer_accepted: auction?.buyer_accepted_seller_terms,
            seller_terms: auction?.seller_terms,
          }"
          (loadData)="getData()"
          [isCatalogue]="true"
          [buyerStatus]="auction?.buyer_status"
          [sellerEmail]="auction?.seller_email"
          [canBid]="
            element.can_bid &&
            (auctionType == 'active' ||
              auctionType == 'wishlist' ||
              auctionType == 'bids')
          "
        ></app-request-to-bid-button>
      }
      @if (
        auctionType == "previous" &&
        (element?.unSold || element?.rna_status) &&
        !element?.make_an_offer?.item_has_accepted_offer &&
        !element?.soldOfflineUser &&
        element?.make_an_offer.time_window_days != 0
      ) {
        <app-make-offer-btn
          class="make-offer-btn"
          [isDisabled]="
            !element?.make_an_offer?.is_available &&
            element?.make_an_offer.time_window_days != 0
          "
          [translations]="catalogueTranslation"
          [dir]="dir"
          [horseId]="element?.id"
          [currencyLocal]="{ locale: locale, currency: auction?.currency }"
        ></app-make-offer-btn>
      }
      <app-auction-item-status
        [isPS]="element?.status === 'ps'"
        [isSold]="element?.soldUser"
        [isRna]="element?.rna_status_offers"
        [isWinner]="element?.winnerUser"
        [isUnSold]="element?.unSold_offers"
        [isReserved]="element?.status === 'reserved' ? true : false"
        [translations]="{
          winner: {
            value: 'horse_info.winner' | translate,
            translationsKey: 'horse_info_winner',
          },
          sold: {
            value: 'horse_info.sold' | translate,
            translationsKey: 'horse_info_sold',
          },
          rna: {
            value: 'horse_info.rna' | translate,
            translationsKey: 'horse_info_rna',
          },
          unsold: {
            value: 'horse_info.unsold' | translate,
            translationsKey: 'horse_info_unsold',
          },
          reserved: {
            value: 'horse_info.reserved' | translate,
            translationsKey: 'horse_info_reserved',
          },
        }"
      ></app-auction-item-status>
    </div>
  }
  @if (element.withdrawn_at != null) {
    <button disabled class="Withdrawn-status">
      {{ "horse_info.withdrawn" | translate }}
    </button>
  }
</ng-template>
<app-live-video-player></app-live-video-player>
